export default (theme) => ({
  itemWrapper: {
    padding: '6px 15px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#F3F5FD',
    },
    '&:focus': {},
  },
  itemInner: {
    flexGrow: '1',
    display: 'flex',
    alignItems: 'stretch',
  },
  missingCL: {
    borderColor: `${theme.palette.borderColor.red}`,
  },
  accordionItemTextWrapper: {
    marginLeft: 10,
  },
  accordionItemImgWrapper: {
    width: '20px',
    height: '20px',
    textAlign: 'center',
    lineHeight: '17px',
    border: '1px solid',
    borderRadius: '3px',
    flexShrink: '0',
  },
  accordionItemLocationWrapper: {
    width: '3px',
    borderLeft: '3px solid',
    textAlign: 'center',
    flexShrink: '0'
  },
  previewCellArrow: {
    cursor: 'pointer',
  },
  closedArrow: {
    transform: 'rotate(90deg)',
  },
  openedArrow: {
    transform: 'rotate(270deg)',
  },
  wlWrapper: {
    height: '200px',
    backgroundColor: 'wheat',
  },
  canceled: {
    textDecoration: 'line-through',
  },
});
